import React, { useEffect, useState, useRef } from 'react'
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import useHttp from "../../../hook/use-http";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5radar from '@amcharts/amcharts5/radar';

function Speedometer({ title, gloablfilter }) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [resData, setresData] = useState([]);

  const chartRef = useRef(null);

  const appyData = (data) => {
    if (data.length > 0) {
      setresData(data);
    } else {
      setresData([]);
    }
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "real_time_fault_code/speedOdometer",
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  useEffect(() => {
    let root = am5.Root.new("chartDivDIC");

    // Set themes
    root.setThemes([am5themes_Animated.new(root)]);

    // Create chart
    let chart = root.container.children.push(
      am5radar.RadarChart.new(root, {
        panX: false,
        panY: false,
        startAngle: 180,
        endAngle: 360,
      })
    );

    // Create axis and its renderer
    let axisRenderer = am5radar.AxisRendererCircular.new(root, {
      innerRadius: -10,
      strokeOpacity: 1,
      strokeWidth: 15,
      strokeGradient: am5.LinearGradient.new(root, {
        rotation: 0,
        stops: [
          { color: am5.color(0x19d228) },
          { color: am5.color(0xf4fb16) },
          { color: am5.color(0xf6d32b) },
          { color: am5.color(0xfb7116) },
        ],
      }),
    });

    let xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        maxDeviation: 0,
        min: 0,
        max: 200,
        strictMinMax: true,
        renderer: axisRenderer,
      })
    );

    // Add clock hand
    let axisDataItem = xAxis.makeDataItem({});
    axisDataItem.set("value", 0);

    axisDataItem.set(
      "bullet",
      am5xy.AxisBullet.new(root, {
        sprite: am5radar.ClockHand.new(root, {
          radius: am5.percent(99),
        }),
      })
    );

    xAxis.createAxisRange(axisDataItem);
    axisDataItem.get("grid").set("visible", false);

    // Store the chart and axisDataItem in chartRef
    chartRef.current = { root, axisDataItem };

    // Make stuff animate on load
    chart.appear(1000, 100);

    root._logo.dispose();

    return () => {
      root.dispose();
    };
  }, [resData]);

  useEffect(() => {
    if (chartRef.current) {
      const { axisDataItem } = chartRef.current;

      // Animate the clock hand
      axisDataItem.animate({
        key: "value",
        to: (resData.length) ? (resData?.[0]?.fields?.Veh_Spd_VCU[0] * 3.6).toFixed(1) : 0,
        duration: 800,
        easing: am5.ease.out(am5.ease.cubic),
      });
    }
  }, [resData]); // Separate useEffect to animate only when resData changes

  return (
    <div className="v-title boxDIC borderDownDIC p-0 indicator_lamp">
      <div className="titlebg boxTitleDIC pb-2 pt-2">{title}</div>
      <div className="position-relative">
        <div id="chartDivDIC" style={{ height: "200px" }}></div>
        <div className="position-absolute top-50 start-50 translate-middle" >
          <span className="d-block text-center fw-bold text-dark">
            <h3 className="m-0">{resData.length > 0 ? (resData?.[0]?.fields?.Veh_Spd_VCU[0] * 3.6).toFixed(1) : 0}</h3>
          </span>
          <span className="d-block text-center fw-bold text-dark">
            <h3 className="m-0">KMPH</h3>
          </span>
        </div>
        <div className="d-flex align-items-center position-relative">
          <label className="vehicle_details_data fw-bold position-absolute" style={{ left: "2rem" }}>
            Odometer
          </label>
          <label className="fw-bold text-center w-100">
            <span className="p-1 text-sm font-weight-bold text-white" style={{ backgroundColor: "#808080", borderRadius: "0.25rem" }}>
              {resData.length > 0 ? resData?.[0]?.fields?.OdoValDiag?.[0] : 0}
            </span>
          </label>
        </div>
      </div>
    </div>
  );
}

export default Speedometer;
